/* eslint-disable @typescript-eslint/ban-types */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, ReplaySubject } from 'rxjs';

import { environment } from '../../../environments/environment';
import { PhoneCode } from '../../models/phone-code';

@Injectable()
export class PhoneCodeService {
  private _codes: ReplaySubject<Object> = new ReplaySubject<Object>();
  public codes$: Observable<Object> = this._codes.asObservable();

  constructor(private _http: HttpClient) {
    this._http
      .get(environment.phoneCodesUrl)
      .subscribe(data => this._codes.next(data as PhoneCode));
  }
}
